const impacts = [
  {
    num: '01',
    cat: 'Public Intelligence',
    title: 'How research informed a sharper public decision.',
    desc: 'A field study turned scattered opinion into a structured evidence base that shaped how a complex public problem was understood and acted upon.',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20a%20stack%20of%20field%20survey%20forms%20and%20clipboards%20with%20a%20pen%20on%20a%20warm%20ivory%20desk%20beside%20a%20magnifying%20glass%2C%20soft%20natural%20window%20light%2C%20deep%20green%20and%20amber%20tones%2C%20authentic%20grounded%20institutional%20mood%2C%20no%20text%20no%20people%20no%20logos&width=800&height=640&seq=prabhaw-impact-01&orientation=portrait',
  },
  {
    num: '02',
    cat: 'Strategic Communication',
    title: 'How a communication challenge became a clear narrative.',
    desc: 'A fragmented public conversation was reframed into a coherent, evidence-led message that reached the right people at the right time.',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20messaging%20and%20narrative%20planning%20documents%20with%20connected%20notes%20and%20a%20quill%20pen%20on%20a%20warm%20paper%20desk%2C%20soft%20directional%20lighting%2C%20deep%20green%20and%20saffron%20amber%20accents%2C%20strategic%20institutional%20mood%2C%20no%20text%20no%20people%20no%20logos&width=800&height=640&seq=prabhaw-impact-02&orientation=portrait',
  },
  {
    num: '03',
    cat: 'Digital Governance',
    title: 'How technology improved a public service.',
    desc: 'A dashboard and MIS brought previously scattered data into one view, giving decision-makers a live, reliable picture of delivery.',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20a%20sleek%20data%20dashboard%20on%20a%20tablet%20beside%20printed%20charts%20and%20a%20stylus%20on%20a%20minimal%20desk%2C%20deep%20emerald%20green%20and%20amber%20gold%20screen%20glow%2C%20modern%20governance%20technology%20mood%2C%20no%20text%20no%20people%20no%20logos&width=800&height=640&seq=prabhaw-impact-03&orientation=portrait',
  },
  {
    num: '04',
    cat: 'Public Outreach',
    title: 'How communication created shared awareness.',
    desc: 'An awareness effort moved people from confusion to clarity, using honest, understandable language grounded in real needs.',
    img: 'https://readdy.ai/api/search-image?query=Editorial%20abstract%20photograph%20of%20community%20outreach%20materials%20and%20flyers%20arranged%20on%20a%20warm%20wooden%20table%20with%20natural%20light%2C%20deep%20green%20and%20warm%20amber%20tones%2C%20human%20connected%20outreach%20mood%2C%20no%20text%20no%20people%20no%20logos&width=800&height=640&seq=prabhaw-impact-04&orientation=portrait',
  },
];

export default function Impact() {
  return (
    <section className="relative w-full bg-background-50 py-20 md:py-28 overflow-hidden">
      <div className="px-6 md:px-16 lg:px-28">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">06 / Impact</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-foreground-950 tracking-tight font-semibold">
              Work that changed how <span className="text-primary-700">decisions get made</span>.
            </h2>
          </div>
          <p data-reveal="fade" className="max-w-sm text-[15px] leading-[1.8] text-foreground-600">
            We measure ourselves by outcomes, not claims. Here is a snapshot of how
            our approach has moved public work forward.
          </p>
        </div>

        {/* Cards */}
        <div data-reveal-stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {impacts.map((im) => (
            <article
              key={im.num}
              className="stagger-child group flex flex-col rounded-2xl overflow-hidden border border-background-200 bg-background-100/40 hover:bg-background-100 transition-colors"
            >
              <div className="img-zoom relative w-full aspect-[4/3.4]">
                <img src={im.img} alt={im.title} className="absolute inset-0 w-full h-full object-cover object-top" />
                <span className="absolute top-4 left-4 text-4xl font-light text-background-50/90" style={{ fontFamily: 'var(--font-heading)' }}>
                  {im.num}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-6">
                <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase text-primary-700 font-mono">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  {im.cat}
                </span>
                <h3 className="mt-3 text-lg leading-snug text-foreground-950 font-semibold group-hover:text-primary-700 transition-colors">
                  {im.title}
                </h3>
                <p className="mt-2 text-[13px] leading-[1.7] text-foreground-600">{im.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}